import sendEventToPiano from './send_event_to_piano';

export function sendCandidateAcceptOfferEvent() {
  sendEventToPiano('click.action', { 'click': 'click accepter_demande' });
}

export function sendCandidateDeclineOfferEvent() {
  sendEventToPiano('click.action', { 'click': 'click refuser_demande' });
}

export function sendCandidateActiveNotDisturbEvent() {
  sendEventToPiano('click.action', { 'click': 'click mode_ne_pas_deranger' });
}

export function sendCandidateSetUnavailabiltyDateEvent() {
  sendEventToPiano('click.action', { 'click': 'click indisponibilite' });
}

export function sendCandidateSignOutEvent() {
  sendEventToPiano('click.action', { 'click': 'click deconnexion_candidats' });
}

export function sendManagerSignOutEvent() {
  sendEventToPiano('click.action', { 'click': 'click deconnexion_direction' });
}



// WEBPACK FOOTER //
// ./src/helpers/at_internet/follow_candidate.js